// extracted by mini-css-extract-plugin
module.exports = {"border":"#e3e6e7","dark":"#1f1f1f","white":"#fff","red":"red","container":"styles_container__ADppq","input":"styles_input__kYeW5","errorMessage":"styles_errorMessage__CYdIa"};